export default {
  connection: null
}
